import {
  getTeamLabelByNumber,
  getDefaultStatisticItem
} from '../../utils/utils'

let isFaceOffPossession = false
let faceOffPoint = null

export default {
  statisticScheme: {
    'TIMEOUT': getDefaultStatisticItem('statistic.hockey.timeouts'),
    'BIG_PENALTY': getDefaultStatisticItem('statistic.hockey.big.penalty'),
    'SMALL_PENALTY': getDefaultStatisticItem('statistic.hockey.small.penalty'),
    'FACE_OFF_DEFENSE': getDefaultStatisticItem('statistic.hockey.face.off.defense'),
    'FACE_OFF_ALL': getDefaultStatisticItem('statistic.hockey.face.off.all'),
    'FACE_OFF_ATTACK': getDefaultStatisticItem('statistic.hockey.face.off.attack')
  },
  statisticEvents: {
    'TIMEOUT': 'TIMEOUT',
    'BIG_PENALTY': ['5_AND_2_MIN_PENALTY', '5_MIN_PENALTY'],
    'SMALL_PENALTY': ['2_MIN_PENALTY', '5_AND_2_MIN_PENALTY']
  },
  statisticOrder: [
    'TIMEOUT',
    'SMALL_PENALTY',
    'BIG_PENALTY',
    'FACE_OFF_ALL',
    'FACE_OFF_ATTACK',
    'FACE_OFF_DEFENSE'
  ],
  statisticFunction (event) {
    twoAndTwoMinPenaltyStatistic.bind(this)(event)
    faceOffStatistic.bind(this)(event)
  },
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}

function getFaceOffScheme (leftSideTeam) {
  return leftSideTeam === 1
    ? {
      'home': {
        1: 'DEFENSE',
        2: 'DEFENSE',
        3: 'DEFENSE',
        4: 'DEFENSE',
        6: 'ATTACK',
        7: 'ATTACK',
        8: 'ATTACK',
        9: 'ATTACK'
      },
      'away': {
        1: 'ATTACK',
        2: 'ATTACK',
        3: 'ATTACK',
        4: 'ATTACK',
        6: 'DEFENSE',
        7: 'DEFENSE',
        8: 'DEFENSE',
        9: 'DEFENSE'
      }
    }
    : {
      'away': {
        1: 'DEFENSE',
        2: 'DEFENSE',
        3: 'DEFENSE',
        4: 'DEFENSE',
        6: 'ATTACK',
        7: 'ATTACK',
        8: 'ATTACK',
        9: 'ATTACK'
      },
      'home': {
        1: 'ATTACK',
        2: 'ATTACK',
        3: 'ATTACK',
        4: 'ATTACK',
        6: 'DEFENSE',
        7: 'DEFENSE',
        8: 'DEFENSE',
        9: 'DEFENSE'
      }
    }
}

function faceOffStatistic (event) {
  const { getIngameData: { leftSideTeam } } = this
  const { EventCode, GamePeriod } = event

  if (EventCode === 'FACE_OFF') {
    const { extra: { point } } = event

    isFaceOffPossession = true
    faceOffPoint = point

    return
  }

  if (!isFaceOffPossession) return

  if (!['POSESSION_1', 'POSESSION_2', 'BETSTART', 'BETSTOP', 'HEARTBEAT', 'START_GAME_CLOCK'].includes(EventCode)) {
    isFaceOffPossession = false
    faceOffPoint = null

    return
  }

  if (EventCode === 'POSESSION_1') {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'FACE_OFF_ALL',
      period: GamePeriod,
      team: 'home',
      type: 'increment'
    })

    const faceOffPosition = getFaceOffScheme(leftSideTeam)['home'][faceOffPoint]

    if (faceOffPosition) {
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: `FACE_OFF_${faceOffPosition}`,
        period: GamePeriod,
        team: 'home',
        type: 'increment'
      })
    }

    isFaceOffPossession = false
    faceOffPoint = null

    return
  }

  if (EventCode === 'POSESSION_2') {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'FACE_OFF_ALL',
      period: GamePeriod,
      team: 'away',
      type: 'increment'
    })

    const faceOffPosition = getFaceOffScheme(leftSideTeam)['away'][faceOffPoint]

    if (faceOffPosition) {
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: `FACE_OFF_${faceOffPosition}`,
        period: GamePeriod,
        team: 'away',
        type: 'increment'
      })
    }

    isFaceOffPossession = false
    faceOffPoint = null
  }
}

function twoAndTwoMinPenaltyStatistic (event) {
  const { EventCode, GamePeriod, TeamNumber } = event

  if (EventCode !== '2_AND_2_MIN_PENALTY') return

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'SMALL_PENALTY',
    period: GamePeriod,
    team: getTeamLabelByNumber(TeamNumber),
    type: 'increment',
    value: 2
  })
}
